import { useState,useEffect } from "react";
import { motion,AnimatePresence } from "framer-motion";
import { BookOpen, Eye, User, FileText, Calendar, Users, Phone, Mail, MapPin, X, ChevronLeft, ChevronRight, Image as ImageIcon  } from "lucide-react";
import { Link } from "react-router-dom";
import axios from "axios";
import PSACSection from '../components/PSACSection';


export default function IqacPage({ 
  accent = "#115e32",
  pageTitle = "The Institutional Quality Assurance Cell (IQAC) | University of Creative Technology Chittagong",
}) {
	useEffect(() => {
		document.title = pageTitle;
	}, [pageTitle]);
  const tabs = [
    { id: "about", label: "About IQAC", icon: <BookOpen size={18} /> },
    { id: "vision", label: "Vision and Mission", icon: <Eye size={18} /> },
    { id: "message", label: "Message from the Director, IQAC", icon: <User size={18} /> },
    { id: "services", label: "Upcoming Training and Events", icon: <FileText size={18} /> },    
    { id: "gallery", label: "IQAC Gallery", icon: <Users size={18} /> },
	{ id: "news", label: "IQAC News", icon: <FileText size={18} /> },
	{ id: "team", label: "IQAC Team", icon: <User size={18} /> },
	{ id: "psac", label: "Program Staff Assessment Committee (PSAC)", icon: <User size={18} /> },
    { id: "contact", label: "Contact IQAC", icon: <Phone size={18} /> },
  ];

	const [activeTab, setActiveTab] = useState("about");
	const [news, setNews] = useState([]);
	const [search, setSearch] = useState("");
	const [filteredNews, setFilteredNews] = useState([]);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);
	const [images, setImages] = useState([]);
	const [currentIndex, setCurrentIndex] = useState(null);
	
	const senior = {
		  
		name: "Mohammad Taher Hossain Salim",
		designation: " Director",
    mobile: "+88 01975138652",
		    
		email: "iqac@uctc.edu.bd",
		address: "Chandgaon Police Station, 1084, Shah Amanat Bridge Connecting Road, Chittagong 4212",
		photo: "assets/teacher/Taher.UCTC.jpeg",
		details: "#",
	};
	const officers = [    
    
    
	{
      name: "Mohammad Injamul Hoq",
      designation: "Additional Director",      
      mobile: "+8801951060585",
      email: " injamul@uctc.edu.bd",
      address: "Chandgaon Police Station, 1084, Shah Amanat Bridge Connecting Road, Chittagong 4212",
      photo: "assets/teacher/97-2003003-inzamamun.jpg",
      details: "#",
    },
	
  ];
	const newsPost = async () => {
		setLoading(true);
		setError(null);

		try {
			const payload = {
				userId: import.meta.env.VITE_API_USER,
				password: import.meta.env.VITE_API_PASS,
				department_id:"10",
		    };
			const api = axios.create({
				baseURL: import.meta.env.VITE_API_BASE_URL,
				headers: { "Content-Type": "application/json" },
			});
			const response = await api.post("/recent-news", payload);
			const data = response.data.slice(0, 48);
			
			// Loop data (array)
			setNews(response.data || []);
			setFilteredNews(data);
		} catch (err) {
		   setError(err.message || "Something went wrong");		   
		} finally {
		  setLoading(false);
		}
	};
	const galleryPost = async () => {
		setLoading(true);
		setError(null);

		try {
			const payload = {
				userId: import.meta.env.VITE_API_USER,
				password: import.meta.env.VITE_API_PASS,
				department_id:'10',
		    };
			const api = axios.create({
				baseURL: import.meta.env.VITE_API_BASE_URL,
				headers: { "Content-Type": "application/json" },				
			});
			const response = await api.post("/gallery", payload);			
			
			// Loop data (array)
			setImages(response.data || []);
		} catch (err) {
		   setError(err.message || "Something went wrong");		   
		} finally {
		  setLoading(false);
		}
	};
	
	useEffect(() => {		
		newsPost();
		galleryPost();
	}, []);
	
	useEffect(() => {
		let result = news;

		if (search) {
			result = result.filter((n) =>
				n.date.toLowerCase().includes(search.toLowerCase())
			);		
			setFilteredNews(result);
		}
	}, [search, news]);
	
	const openLightbox = (index) => setCurrentIndex(index);
	const closeLightbox = () => setCurrentIndex(null);

	const prevImage = () =>
		setCurrentIndex((prev) => (prev > 0 ? prev - 1 : images.length - 1));
	const nextImage = () =>
		setCurrentIndex((prev) => (prev < images.length - 1 ? prev + 1 : 0));
  const content = {
    about: (
	 <>
      <p> 
		<strong>About IQAC</strong><br/>
		Institutional Quality Assurance Cell (IQAC) is an essential part of a university to ensure quality of learning and training programs in higher education. In order to maintain the quality of higher education, it was first adopted in 1900 in the United States of America. As a second country Japan adopted this method in 1946. Then other countries of the world started following this process. The present government headed by the Hon’ble Prime Minister Sheikh Hasina is committed to change the landscape of higher education through enhancement of quality of higher education and research in the country. For achieving the target of quality education, the Government of Bangladesh (GoB) and the World Bank has generously funded the project which is known as Higher Education Quality Enhancement Project (HEQEP). The project is being implemented by the University Grants Commission, with help of the project officials and that of by the World Bank. The IQAC of UCTC was established in July 2020 in order to ensure quality education at the tertiary level and aims to meet the demands of contemporary times. Since quality enhancement is a continuous process, the IQAC, UCTC is trying to become a part of an institution's system and work towards realizing the goals of quality enhancement and sustenance. The prime aim of the IQAC of UCTC is to develop a system for conscious, consistent and catalytic improvement in the performance of institutions. Moreover, IQAC is trying to identify the gaps between the existing system and stakeholder demands and to enhance and maintain the standards of quality of higher education up to the international standards. At present, UCTC-IQAC is working to assess all 6 departments academic program to find out the major strength, opportunity, and weakness. For instance, IQAC has organized the following programs.
		
	  </p>
	  <ul className="space-y-4">
			<li className="flex items-start gap-3 p-4 rounded-lg bg-gradient-to-r from-[#D6F5FE] to-[#E6FAFE] shadow-sm hover:shadow-md transition-all duration-300">
			  <span className="text-[#d4af37] font-bold">a)</span>
			  <p className="text-gray-700 leading-relaxed">
				Inter and intra institutional workshops, seminars on quality related themes and promotion of quality circles.
			  </p>
			</li>
			<li className="flex items-start gap-3 p-4 rounded-lg bg-gradient-to-r from-[#D6F5FE] to-[#E6FAFE] shadow-sm hover:shadow-md transition-all duration-300">
			  <span className="text-[#d4af37] font-bold">b)</span>
			  <p className="text-gray-700 leading-relaxed">
				Workshop and seminar on awareness, motivation, and way of conducting research and report writing.
			  </p>
			</li>
			<li className="flex items-start gap-3 p-4 rounded-lg bg-gradient-to-r from-[#D6F5FE] to-[#E6FAFE] shadow-sm hover:shadow-md transition-all duration-300">
			  <span className="text-[#d4af37] font-bold">c)</span>
			  <p className="text-gray-700 leading-relaxed">
				Development of Quality Culture in the University
			  </p>
			</li>
			<li className="flex items-start gap-3 p-4 rounded-lg bg-gradient-to-r from-[#D6F5FE] to-[#E6FAFE] shadow-sm hover:shadow-md transition-all duration-300">
			  <span className="text-[#d4af37] font-bold">d)</span>
			  <p className="text-gray-700 leading-relaxed">
				Meeting with stakeholders: Sharing views and opinions with Alumni, employers, guardians, and students.
			  </p>
			</li>
			
		</ul>	
		</>
    ),
    vision: (
      <p>
      </p>
    ),
    message: (
      <p>
		<strong>Message from the Director, IQAC</strong><br/>
        Welcome to IQAC at University of Creative Technology Chittagong (UCTC). The Institutional Quality Assurance Cell (IQAC) of UCTC was established in July 2020 in order to ensure quality education at the tertiary level and aims to meet the demands of contemporary times. Since its initiation, UCTC-IQAC is functioning to adopt Outcome Based Education (OBE) as the central application of the University. It will not only incorporate the critical and creative thinking skills among our graduates but also help to improve the skills on decision making, cognitive flexibility and coordination ability. UCTC aims to initiate the culture of evidence-based quality education and create sustainable environment by prioritizing need-based research. I seek your valuable support and cooperation in this journey of IQAC and I truly hope, with your support, IQAC at UCTC can become a center of excellency in the Higher Education sector of Bangladesh.
	  </p>
    ),
    services: (
		<div className="w-full animate-fadeInRight">
            
        </div>
    ),
    gallery: (
		<section className="container mx-auto px-6 py-16">
        {images.length === 0 ? (
          <p className="text-center text-gray-500">Loading gallery...</p>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {images.map((img, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.5, delay: i * 0.05 }}
                viewport={{ once: true }}
                onClick={() => openLightbox(i)}
                className="relative overflow-hidden rounded-xl shadow-lg group cursor-pointer"
              >
                <img
                  src={`${import.meta.env.VITE_API_SOURCE_URL}${img.picture}`}
                  alt={img.title}
                  className="w-full h-64 object-cover transform group-hover:scale-110 transition duration-500"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent text-white p-4 opacity-0 group-hover:opacity-100 transition">
                  <h3 className="text-lg font-semibold">{img.title}</h3>
                </div>
              </motion.div>
            ))}
          </div>
        )}
      </section>
    ),
    
	news: (
       <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="flex flex-col md:flex-row items-center justify-between mb-6">
          <h2 className="text-2xl font-bold text-[#014864]">Latest News</h2>

          {/* Search Box */}
          <input
            type="text"
            placeholder="Search news..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="mt-3 md:mt-0 border border-gray-300 rounded-lg px-4 py-2 w-full md:w-64 focus:outline-none focus:ring-2 focus:ring-gray-500"
          />
        </div>

        {/* News Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {filteredNews.length > 0 ? (
            filteredNews.map((item) => (
              <div
                key={item.id}
                className="bg-white rounded-xl shadow hover:shadow-lg transition duration-300 overflow-hidden"
              >
                {/* Image */}
                <img
                  src={
                    item.images_path
                      ? import.meta.env.VITE_API_SOURCE_URL + item.images_path
                      : "https://via.placeholder.com/400x250?text=No+Image"
                  }
                  alt={item.head_line}
                  className="w-full h-48 object-cover"
                />

                {/* Content */}
                <div className="p-4">
                  <h3 className="text-lg font-semibold text-gray-800 mb-2 line-clamp-2">
                    {item.head_line}
                  </h3>
                  <p className="text-sm text-gray-500 mb-3">
                    {new Date(item.date).toLocaleDateString()}
                  </p>

                  <Link
                    to={`/news/${item.id}`}
                    className="inline-block bg-[#014864] text-white text-sm font-medium px-4 py-2 rounded-lg hover:bg-gray-700 transition"
                  >
                    Read More
                  </Link>
                </div>
              </div>
            ))
          ) : (
            <p className="col-span-4 text-center text-gray-500">
              No news found.
            </p>
          )}
        </div>
      </div>
    ),
	team: (
      <>
		<section className="container mx-auto px-6 py-16">
			<motion.div
			  initial={{ scale: 0.9, opacity: 0 }}
			  animate={{ scale: 1, opacity: 1 }}
			  transition={{ duration: 1 }}
			  className="bg-white rounded-2xl shadow-lg p-8 flex flex-col md:flex-row items-center gap-8 hover:shadow-xl transition-all duration-300"
			>
			  <img
				src={`${import.meta.env.VITE_API_SOURCE_URL}${senior.photo}`}
				alt={senior.name}
				className="w-48 h-56 object-cover rounded-xl border-4 border-[#014864]"
			  />
			  <div className="flex-1 space-y-3">
				<h2 className="text-2xl font-bold text-gray-800">{senior.name}</h2>
				<p className="text-[#2563eb] font-semibold">{senior.designation}</p>
				<p className="text-gray-600">{senior.office}</p>
				<div className="space-y-1 text-gray-600 text-sm">
				  <p className="flex items-center gap-2"><Phone size={16}/> {senior.mobile}</p>
				  <p className="flex items-center gap-2"><Mail size={16}/> {senior.email}</p>
				  <p className="flex items-center gap-2"><MapPin size={16}/> {senior.address}</p>
				</div>
				<a
				  href={senior.details}
				  className="inline-block mt-4 px-6 py-2 bg-gradient-to-r from-[#014864] to-[#2563eb] text-white rounded-lg shadow hover:opacity-90 transition"
				>
				  View Details
				</a>
			  </div>
			</motion.div>
		</section>
		<section className="container mx-auto px-6 pb-20">
			<div className="grid md:grid-cols-3 gap-8">
			  {officers.map((officer, index) => (
				<motion.div
				  key={index}
				  initial={{ y: 40, opacity: 0 }}
				  whileInView={{ y: 0, opacity: 1 }}
				  transition={{ duration: 0.8, delay: index * 0.2 }}
				  className="bg-white rounded-xl shadow-lg p-6 text-center hover:shadow-xl transition-all duration-300"
				>
				  <img
					src={`${import.meta.env.VITE_API_SOURCE_URL}${officer.photo}`}
					alt={officer.name}
					className="w-32 h-40 mx-auto rounded-lg object-cover border-2 border-[#2563eb]"
				  />
				  <h3 className="mt-4 text-xl font-bold text-gray-800">
					{officer.name}
				  </h3>
				  <p className="text-[#2563eb] text-sm font-semibold">
					{officer.designation}
				  </p>				  
				  <div className="mt-3 text-gray-600 text-sm space-y-1">
					<p className="flex items-center justify-center gap-2">
					  <Phone size={14}/> {officer.mobile}
					</p>
					<p className="flex items-center justify-center gap-2">
					  <Mail size={14}/> {officer.email}
					</p>
					<p className="flex items-center justify-center gap-2">
					  <MapPin size={14}/> {officer.address}
					</p>
				  </div>
				  <a
					href={officer.details}
					className="inline-block mt-4 px-4 py-2 bg-gradient-to-r from-[#014864] to-[#2563eb] text-white rounded-lg text-sm hover:opacity-90 transition"
				  >
					View Details
				  </a>
				</motion.div>
			  ))}
			</div>
		</section>
	  </>
    ),
	psac: (
	  <>
		<section className="container mx-auto px-6 py-5">
			<h2 className="text-2xl font-bold text-[#014864]">Program Staff Assessment Committee (PSAC)</h2>
		</section>
		<PSACSection />
	  </>
	),
    contact: (
      <p>
		<strong>Contact The Institutional Quality Assurance Cell (IQAC) to the following;;</strong><br/>
		<strong>Location:</strong> 1st Floor, UCTC Campus<br/>
		<strong>Hours:</strong> Monday through Saturday, 9.00 AM to 6.00 PM<br/>
        <strong>Email:</strong> iqac@uctc.edu.bd <br />
        <strong>Phone:</strong> 8801707507071 <br />
        <strong>Mailing Address:</strong> Student Affairs Division, University of Creative Technology, Chittagong, 1084, Near New Chandgaon Police Station, Shah Amanat Bridge Connecting Road, Bahaddarhat, Chittagong, Bangladesh
      </p>
    ),
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-white via-[#fffdf7] to-white">
      {/* Hero Section with SVG */}
      <section className="relative bg-gradient-to-r from-[#B7EAFC] via-[#D6F5FE] to-[#E6FAFE] text-[#014864] py-20 overflow-hidden">
        {/* SVG Wave */}
        <svg
          className="absolute bottom-0 left-0 w-full h-20 text-white"
          viewBox="0 0 1440 320"
          fill="currentColor"
        >
          <path
            fillOpacity="1"
            d="M0,192L80,202.7C160,213,320,235,480,224C640,213,800,171,960,144C1120,117,1280,107,1360,101.3L1440,96V320H0Z"
          ></path>
        </svg>
        <div className="relative container mx-auto text-center z-10">
          <motion.h1
            initial={{ y: -40, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 1 }}
            className="text-4xl md:text-6xl font-extrabold"
          >
            The Institutional Quality Assurance Cell (IQAC)
          </motion.h1>
          <p className="mt-4 text-lg opacity-90">
            Supporting students’ academic journey, leadership, and campus life.
          </p>
        </div>
      </section>

      {/* Main Content */}
      <section className="mx-auto px-6 py-16 grid md:grid-cols-4 gap-8">
        {/* Left Menu */}
        <div className="col-span-1 bg-white rounded-xl shadow-lg p-6">
          <ul className="space-y-3">
            {tabs.map((tab) => (
              <li key={tab.id}>
                <button
                  onClick={() => setActiveTab(tab.id)}
                  className={`flex items-center gap-2 w-full px-4 py-2 rounded-lg text-left transition ${
                    activeTab === tab.id
                      ? "bg-gradient-to-r from-[#2563eb] to-[#014864] text-white shadow"
                      : "text-gray-700 hover:bg-gray-100"
                  }`}
                >
                  {tab.icon} {tab.label}
                </button>
              </li>
            ))}
          </ul>
        </div>

        {/* Right Content */}
        <motion.div
          key={activeTab}
          initial={{ opacity: 0, x: 50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6 }}
          className="col-span-3 bg-white rounded-xl shadow-lg p-8 text-gray-700 leading-relaxed"
        >
          {content[activeTab]}
        </motion.div>
      </section>
	  
	   <AnimatePresence>
        {currentIndex !== null && (
          <motion.div
            className="fixed inset-0 bg-black/90 flex items-center justify-center z-50"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            {/* Close Button */}
            <button
              onClick={closeLightbox}
              className="absolute top-6 right-6 text-white hover:text-red-400"
            >
              <X className="w-8 h-8" />
            </button>

            {/* Prev Button */}
            <button
              onClick={prevImage}
              className="absolute left-6 text-white hover:text-green-400"
            >
              <ChevronLeft className="w-10 h-10" />
            </button>

            {/* Next Button */}
            <button
              onClick={nextImage}
              className="absolute right-6 text-white hover:text-green-400"
            >
              <ChevronRight className="w-10 h-10" />
            </button>

            {/* Image */}
            <motion.div
              key={currentIndex}
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.8, opacity: 0 }}
              transition={{ duration: 0.4 }}
              className="text-center"
            >
              <img
                src={`${import.meta.env.VITE_API_SOURCE_URL}${images[currentIndex].picture}`}
                alt={images[currentIndex].title}
                className="max-h-[80vh] max-w-[90vw] rounded-lg shadow-lg mx-auto"
              />
              <p className="text-white mt-4 text-lg">
                {images[currentIndex].title}
              </p>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
